import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import MCSReadonlyField from "../../../../components/MCSReadonlyField";

const ExampleNotificationEmail = (props) => {
    const { emailEvent } = props;

    return (
        <>
            <Row>
                <Col>
                    <MCSReadonlyField label="Sender Info" text={emailEvent?.emailSenderInfo} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <MCSReadonlyField label="Email Subject" text={emailEvent?.emailSubject} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <MCSReadonlyField label="Email Body" text="" />
                    <div dangerouslySetInnerHTML={{
                        __html: emailEvent.emailTemplateContent
                    }} />
                </Col>
            </Row>
        </>
    );
};

export default ExampleNotificationEmail;
